import { useEffect, useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import { FaPlus, FaEdit, FaTrash, FaQuestionCircle, FaSave, FaTimes, FaTags } from "react-icons/fa";
import "assets/theme/admin_list.css";

const HelpCategoryList = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");

  const loadCategories = async () => {
    setLoading(true);
    try {
      const data = await apiFetch("super_admin/list_help_category");
      setCategories(data.categories || []);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure? / आपण खात्री आहात का?")) return;

    try {
      await apiFetch(`super_admin/delete_help_category/${id}`, { method: "DELETE" });
      setCategories((prev) => prev.filter((item) => item.category_id !== id));
    } catch (error) {
      alert(error.message);
    }
  };

  const handleUpdate = async (id) => {
    if (!editValue.trim()) return alert("Category name required");

    try {
      await apiFetch(`super_admin/edit_help_category/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ category_name: editValue.trim() }),
      });

      setCategories((prev) =>
        prev.map((item) =>
          item.category_id === id ? { ...item, category_name: editValue } : item
        )
      );
      setEditingId(null);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid py-3">
        {/* Header Card */}
        <div className="admin-header-card mb-4">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 position-relative" style={{ zIndex: 1 }}>
            <div className="d-flex align-items-center gap-3">
              <div className="admin-header-icon-box">
                <FaQuestionCircle />
              </div>
              <div>
                <h4 className="text-white fw-bold mb-1" style={{ fontSize: "1.3rem" }}>
                  Help Category List / मदत श्रेणी यादी
                </h4>
                <p className="text-white-50 mb-0" style={{ fontSize: "0.88rem" }}>
                  Manage assistance categories and official support channels
                </p>
              </div>
            </div>

            <Link to="/help_category" className="btn btn-admin-add">
              <FaPlus /> <span>Add Category / श्रेणी जोडा</span>
            </Link>
          </div>
        </div>

        {/* List Card */}
        <div className="admin-table-card">
          <div className="card-body p-0">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-warning" role="status"></div>
                <p className="text-muted mt-2 fw-semibold mb-0">माहिती लोड होत आहे...</p>
              </div>
            ) : categories.length === 0 ? (
              <div className="text-center py-5">
                <FaTags className="text-muted mb-3" style={{ fontSize: "2.5rem", opacity: 0.4 }} />
                <h6 className="text-muted fw-bold">No categories found</h6>
                <p className="text-muted small mb-0">No help categories are currently available.</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-admin-custom align-middle">
                  <thead>
                    <tr>
                      <th style={{ width: "80px" }}>Sr. No.</th>
                      <th>Category Name / श्रेणीचे नाव</th>
                      <th className="text-center" style={{ width: "160px" }}>Actions / क्रिया</th>
                    </tr>
                  </thead>
                  <tbody>
                    {categories.map((item, index) => (
                      <tr key={item.category_id}>
                        <td>
                          <span className="fw-semibold text-muted">{(index + 1).toString().padStart(2, "0")}</span>
                        </td>
                        <td>
                          {editingId === item.category_id ? (
                            <input
                              type="text"
                              className="form-control form-control-sm border-warning fw-semibold shadow-sm"
                              value={editValue}
                              onChange={(e) => setEditValue(e.target.value)}
                              autoFocus
                            />
                          ) : (
                            <span className="fw-bold text-dark">{item.category_name}</span>
                          )}
                        </td>
                        <td>
                          <div className="d-flex justify-content-center gap-2">
                            {editingId === item.category_id ? (
                              <>
                                <button
                                  className="btn btn-sm btn-success px-3 fw-semibold text-white d-flex align-items-center gap-1"
                                  onClick={() => handleUpdate(item.category_id)}
                                >
                                  <FaSave /> <span>Save</span>
                                </button>
                                <button
                                  className="btn btn-sm btn-secondary px-2 d-flex align-items-center gap-1"
                                  onClick={() => setEditingId(null)}
                                >
                                  <FaTimes />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn-action-icon edit"
                                  title="Edit Category"
                                  onClick={() => {
                                    setEditingId(item.category_id);
                                    setEditValue(item.category_name);
                                  }}
                                >
                                  <FaEdit />
                                </button>
                                <button
                                  className="btn-action-icon delete"
                                  title="Delete Category"
                                  onClick={() => handleDelete(item.category_id)}
                                >
                                  <FaTrash />
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default HelpCategoryList;
